import { render, staticRenderFns } from "./Comparador.vue?vue&type=template&id=759369ef&scoped=true"
import script from "./Comparador.vue?vue&type=script&lang=js"
export * from "./Comparador.vue?vue&type=script&lang=js"
import style0 from "./Comparador.vue?vue&type=style&index=0&id=759369ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759369ef",
  null
  
)

export default component.exports